import { Item__Atividades, ItemPropriedades } from "../../../../../services/atividades/GET";

export type TalhaoFinalizadoSaida = {
    cod_talhao: number;
    cod_propriedade: number;
    nome_talhao: string;
    nome_propriedade: string;
    atvs_planejadas: Item__Atividades[];
    atvs_executadas: Item__Atividades[];
    is_concluido: boolean;
    atvs_concluidas: Item__Atividades[];
}

export function talhoesFinalizados(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[]): { finalizados: TalhaoFinalizadoSaida[], talhoes: TalhaoFinalizadoSaida[] } {


    let atvs_concluidas = (data_atividades ?? []).filter(atv => atv.cod_tipo === 1 && atv.concluido === true);
    //@ts-ignore
    let talhoes = (data_propriedades?.flat() ?? []).map(i => i.talhao)?.flat();
    let talhoes_com_safra = (talhoes ?? [])?.filter(i => i.cod_safra !== null && i.cod_talhao === null);

    let atividades_por_talhao = (talhoes_com_safra ?? []).map((item) => {
        let atvs_talhoes = (data_atividades ?? []).filter(atv => atv.cod_tipo === 1 && atv.cod_talhao === item.cod && atv.delete_time === null);
        let atvs_talhao_concluidas = atvs_concluidas.filter(atv => atv.cod_talhao === item.cod && atv.delete_time === null);
        return {
            cod_talhao: item.cod,
            cod_propriedade: item.cod_propriedade,
            nome_talhao: item.nome,
            nome_propriedade: (data_propriedades ?? []).find(i => i.cod === item.cod_propriedade)?.nome || '',
            atvs_planejadas: atvs_talhoes,
            atvs_executadas: (data_atividades ?? []).filter(atv => atv.cod_tipo === 2 && atv.cod_talhao === item.cod && atv.delete_time === null),
            is_concluido: atvs_talhao_concluidas.length === 0 ? false : (atvs_talhao_concluidas).length === (atvs_talhoes).length,
            atvs_concluidas: atvs_talhao_concluidas
        }
    })

    return {
        finalizados: atividades_por_talhao.filter(i => i.is_concluido === true),
        talhoes: atividades_por_talhao
    };
}